var __jsx = React.createElement;
import * as React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import * as ds from '@bob/design-system';
import * as url from '@bob/url';
import { MomentIcon } from './MomentIcon';
export function MomentStickers(_ref) {
  var moments = _ref.moments;
  var columns = getColumnNumber(moments.length);
  return __jsx(StickerGrid, null, Array.from({
    length: columns
  }).map(function (_, column) {
    return __jsx(StickerColumn, {
      key: column
    }, moments.map(function (moment, i) {
      if (i % columns === column) {
        var sticker = __jsx(Sticker, {
          key: moment.icon + '-' + i
        }, __jsx(MomentIcon, {
          icon: moment.icon,
          size: 80
        }));

        if (moment.slug !== undefined) {
          return __jsx(Link, {
            href: url.products({
              params: {
                moments: moment.slug
              }
            }).path,
            key: moment.icon + '-' + i,
            prefetch: false
          }, __jsx("a", null, sticker));
        }

        return sticker;
      }
    }));
  }));
}
var Sticker = styled.div.withConfig({
  displayName: "MomentStickers__Sticker",
  componentId: "sc-1kegfeo-0"
})(["padding:6px 17px;@media screen and (", "){", "{height:185px;width:auto;}}"], ds.breakpoint.TABLET, ds.stickers.Sticker);
var StickerColumn = styled.div.withConfig({
  displayName: "MomentStickers__StickerColumn",
  componentId: "sc-1kegfeo-1"
})(["display:flex;flex-direction:column;"]);
var StickerGrid = styled.div.withConfig({
  displayName: "MomentStickers__StickerGrid",
  componentId: "sc-1kegfeo-2"
})(["margin-top:40px;margin-bottom:40px;display:flex;flex-direction:row;", ":nth-child(odd){margin-top:", "px;}"], StickerColumn, 185 / 4);

function getColumnNumber(size) {
  if (size <= 3) {
    return size;
  }

  var closest = {
    score: Infinity,
    repeat: 5
  };

  for (var columns = 2; columns <= 5; columns++) {
    var lines = Math.ceil(size / columns);
    var score = columns * lines - size;
    /* when we have more than 3 stickers :
    - we exclude any disposition on less than two line
    - we exclude any disposition that is taller than wider (we want squares or "laying" rectangle, no "standing" rectangle)
    - within included disposition we prefere dispositions that is closer to a full rectangle
    */

    if (lines >= 2 && lines <= columns && score < closest.score) {
      closest.score = score;
      closest.repeat = columns;
    }
  }

  return closest.repeat;
}